import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ENV } from '@di-tokens';
import { PromoBanner } from '@models';
import { map, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PromoBannerService {
  http = inject(HttpClient);
  ENV = inject(ENV);

  private readonly domain = this.ENV.remoteApi;

  getList(): Observable<PromoBanner[]> {
    return this.http.get<PromoBanner[]>(this.domain + `/promo-banners`).pipe(
      // `{Link}` slides advertise the retired Points Accelerator
      map((response) =>
        response.filter((slide) => slide.linkLabel !== '{Link}').sort((a, b) => a.orderNumber - b.orderNumber),
      ),
    );
  }
}
